export default "__VITE_ASSET__DOw7wWBg__"